import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  changeFieldTimeChecking,
  changeFieldCheckDesc,
  changeFieldRequireLinkInReport,
  changeFieldRequireScreenshotInReport
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import {
  selectFieldTimeChecking,
  selectFieldCheckDesc,
  selectFieldRequireLinkInReport,
  selectFieldRequireScreenshotInReport,
  selectAllErrors,
  selectFieldTypeId
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import {
  getItemFromRefList,
  getValueFromRefDataModules
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import connect from 'react-redux/es/connect/connect';
import _ from 'lodash';
import { t } from 'utils/translates';
import DefaultSelect from '../../../../Common/Inputs/DefaultSelect';

class CheckTypeManualInputs extends Component {
  constructor(props) {
    super(props);
    this.inputsRefs = {
      [props.fieldTimeChecking.field]: React.createRef(),
      [props.fieldCheckDesc.field]: React.createRef()
    };
  }

  componentDidUpdate(prevProps) {
    if (_.isEmpty(prevProps.allErrors) && !_.isEmpty(this.props.allErrors)) {
      const firstErrorField = Object.keys(this.props.allErrors)[0];
      const scrollRef = this.inputsRefs[firstErrorField];
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  render() {
    let maxTimeCheckingMinutes;
    if (this.props.fieldTypeId.value) {
      const found = this.props.taskTypes.find(
        item =>
          item.value.toString() === this.props.fieldTypeId.value.toString()
      );
      if (found) {
        maxTimeCheckingMinutes = parseInt(found.max_time_checking_minutes, 10);
      }
    }
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
            <small className="divider" />
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <React.Fragment>
        <div className="tab-pane active" id="manual-check">
          <div
            className={`form-group ${
              hasError(this.props.fieldTimeChecking.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label" htmlFor="time_checking">
              {t('Время на проверку')}
            </label>
            <DefaultSelect
              ref={this.inputsRefs[this.props.fieldTimeChecking.field]}
              selectArrItems={Object.keys(this.props.taskIntervalExecution)
                .map(key => ({
                  value: key,
                  title: this.props.taskIntervalExecution[key]
                }))
                .filter(item => {
                  const valueInt = parseInt(item.value, 10);
                  if (maxTimeCheckingMinutes) {
                    return valueInt <= maxTimeCheckingMinutes;
                  }
                  return valueInt <= 4320;
                })}
              value={this.props.fieldTimeChecking.value}
              handleChangeValue={value => {
                this.props.changeFieldTimeChecking(value);
              }}
            />
            {errorDesc(this.props.fieldTimeChecking.errors)}
            <small className="help-block">
              {t(
                'Время, за которое вы обязуетесь проверить задание. Если вы не уложитесь в срок, его выполнение будет считаться проверенным, а зарезервированные средства перейдут на баланс исполнителя.'
              )}
            </small>
          </div>
          <div
            className={`form-group m-b-0 ${
              hasError(this.props.fieldCheckDesc.errors) ? 'has-error' : ''
            }`}
          >
            <label className="control-label" htmlFor="infoConfirm">
              {t('Информация для подтверждения')}
            </label>
            <textarea
              ref={this.inputsRefs[this.props.fieldCheckDesc.field]}
              className="form-control"
              id="infoConfirm"
              minLength="100"
              name="infoConfirm"
              rows="8"
              value={this.props.fieldCheckDesc.value}
              onChange={e => this.props.changeFieldCheckDesc(e.target.value)}
            />
            {errorDesc(this.props.fieldCheckDesc.errors)}
            <small className="help-block m-b-0">
              {t(
                'Напишите <strong>какую информацию</strong> пользователь должен <strong>оставить в отчёте</strong>, чтобы вы проверили правильность выполнения задания. Не меньше 100 символов.'
              )}
            </small>
          </div>
          <div className="col-xs-24 col-sm-12 col-md-12 m-b-10">
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                ref={this.inputsRefs[this.props.fieldRequireLinkInReport.field]}
                className="styled"
                id="checkboxRequireLinkInReport"
                type="checkbox"
                checked={
                  this.props.fieldRequireLinkInReport.value === '1'
                    ? 'checked'
                    : ''
                }
                onChange={() =>
                  this.props.changeFieldRequireLinkInReport(
                    this.props.fieldRequireLinkInReport.value === '1'
                      ? '0'
                      : '1'
                  )
                }
              />
              <label htmlFor="checkboxRequireLinkInReport">
                <div className="text-strong m-b-4">
                  {t('Необходимо наличие ссылки в отчете')}
                </div>
                {t(
                  'Необходимо отметить, если для выполнения вашего задания исполнителю необходимо передать ссылку в отчете'
                )}
              </label>
            </div>
          </div>
          <div className="col-xs-24 col-sm-12 col-md-12">
            <div className="checkbox abc-checkbox abc-checkbox-primary">
              <input
                ref={
                  this.inputsRefs[
                    this.props.fieldRequireScreenshotInReport.field
                  ]
                }
                className="styled"
                id="checkboxRequireScreenshotInReport"
                type="checkbox"
                checked={
                  this.props.fieldRequireScreenshotInReport.value === '1'
                    ? 'checked'
                    : ''
                }
                onChange={() =>
                  this.props.changeFieldRequireScreenshotInReport(
                    this.props.fieldRequireScreenshotInReport.value === '1'
                      ? '0'
                      : '1'
                  )
                }
              />
              <label htmlFor="checkboxRequireScreenshotInReport">
                <div className="text-strong m-b-4">
                  {t('Необходимо наличие скриншота в отчете')}
                </div>
                {t(
                  'Необходимо отметить, если для выполнения вашего задания исполнителю необходимо прикрепить скриншот к отчету'
                )}
              </label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

CheckTypeManualInputs.propTypes = {
  fieldTimeChecking: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldCheckDesc: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldRequireLinkInReport: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldRequireScreenshotInReport: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired,
  allErrors: PropTypes.shape({}).isRequired,
  changeFieldTimeChecking: PropTypes.func.isRequired,
  changeFieldCheckDesc: PropTypes.func.isRequired,
  changeFieldRequireLinkInReport: PropTypes.func.isRequired,
  changeFieldRequireScreenshotInReport: PropTypes.func.isRequired,
  taskIntervalExecution: PropTypes.shape({}).isRequired,
  taskTypes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  fieldTypeId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any,
    errors: PropTypes.array.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldTimeChecking: selectFieldTimeChecking(state, props.reducerName),
  fieldCheckDesc: selectFieldCheckDesc(state, props.reducerName),
  fieldRequireLinkInReport: selectFieldRequireLinkInReport(
    state,
    props.reducerName
  ),
  fieldRequireScreenshotInReport: selectFieldRequireScreenshotInReport(
    state,
    props.reducerName
  ),
  allErrors: selectAllErrors(state, props.reducerName),
  taskIntervalExecution: getItemFromRefList(state, 'taskIntervalExecution'),
  taskTypes: getValueFromRefDataModules(state, 'tasks.taskTypes'),
  fieldTypeId: selectFieldTypeId(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTimeChecking: value =>
    dispatch(changeFieldTimeChecking(props.reducerName, value)),
  changeFieldCheckDesc: value =>
    dispatch(changeFieldCheckDesc(props.reducerName, value)),
  changeFieldRequireLinkInReport: value =>
    dispatch(changeFieldRequireLinkInReport(props.reducerName, value)),
  changeFieldRequireScreenshotInReport: value =>
    dispatch(changeFieldRequireScreenshotInReport(props.reducerName, value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckTypeManualInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeManualInputs/CheckTypeManualInputs.js